(function ($) {
    $(".menu-toggle").on("click", function () {
        $(this).toggleClass("open");
        $(".mobile-menu").toggleClass("open");
    });
    $(".mobile-menu-close, .home-page").on("click", function () {
        $(".menu-toggle").removeClass("open");
        $(".mobile-menu").removeClass("open");
    });
    $(".mobile-open-submenu").on("click", function (e) {
        e.preventDefault();
        $(this).closest(".mobile-menu__inner").addClass("open-submenu");
        $(this).closest("li").addClass("open-submenu");
    });
    $(".mobile-menu-back").on("click", function (e) {
        e.preventDefault();
        $(".mobile-menu__inner").removeClass("open-submenu");
        $(".mobile-menu li").removeClass("open-submenu");
    });
    $(".footer__nav-item h2").on("click", function () {
        $(this).closest(".footer__nav-item").toggleClass("open");
    });
})(jQuery);